package fr.frux.feature.site.detail

import androidx.compose.runtime.Composable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.lifecycle.viewmodel.compose.viewModel

/**
 * Contrat de fabrique du [SiteDetailViewModel], honoré par le composition root (#43).
 *
 * `siteId` vient de la route, pas du graphe : c'est le seul paramètre que l'appelant fournit.
 */
fun interface SiteDetailViewModelFactory {
    fun create(siteId: Long): SiteDetailViewModel
}

/** Fabrique installée par le composition root, sans défaut : l'oubli de câblage doit crier. */
val LocalSiteDetailViewModelFactory =
    staticCompositionLocalOf<SiteDetailViewModelFactory> {
        error(
            "SiteDetailViewModelFactory absente : le composition root doit l'installer " +
                "(cf. FruxCompositionRoot, #43)",
        )
    }

@Composable
fun rememberSiteDetailViewModel(siteId: Long): SiteDetailViewModel {
    val factory = LocalSiteDetailViewModelFactory.current
    return viewModel { factory.create(siteId) }
}
